import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/koinworx.webp';
import screenshot_target from '../../../images/letterfunnel/arunkumar.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Arun Kumar"
      firstname="Arun"
      companyname="KoinWorx"
      competition="Protokol en Linden IT"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/arunkumar.js